export const column = [
  { key: '1', headerName: 'S.No', field: 'sno', hide: false, width: 300 },
  { key: '2', headerName: 'ID/code', field: 'id', hide: false, width: 300 },
  { key: '3', headerName: 'Category', field: 'category', hide: false, width: 160 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 300 },
];
